import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';

import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
    imports: [
      MatExpansionModule,
      MatGridListModule,
      MatToolbarModule,
      MatSidenavModule,
      MatTableModule,
      MatPaginatorModule,
      MatCardModule,
      MatButtonModule,
      MatButtonToggleModule,
      MatInputModule,
      MatSelectModule,
      MatAutocompleteModule,
      MatCheckboxModule,
      MatCardModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatSlideToggleModule,
      MatGridListModule,
      MatIconModule,
      MatIconModule,
      MatInputModule,
      MatDialogModule,
      MatBottomSheetModule,
      MatCardModule,
      MatTooltipModule,
      MatChipsModule,
      MatDividerModule,
      MatProgressSpinnerModule,
      MatProgressBarModule
    ],
    exports: [
        MatGridListModule,
        MatToolbarModule,
        MatSidenavModule,
        MatTableModule,
        MatPaginatorModule,
        MatCardModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatInputModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatCardModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSlideToggleModule,
        MatGridListModule,
        MatIconModule,
        MatIconModule,
        MatInputModule,
        MatDialogModule,
        MatBottomSheetModule,
        MatCardModule,
        MatTooltipModule,
        MatChipsModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatStepperModule,
        MatFormFieldModule,
      ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
      { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },
      {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS}
    ]
  })
  export class AppMaterialComponentsModule { }